import get from "lodash/get";
import { useQuery } from "react-query";

import * as Api from "../api";
import * as Constants from "../constants";
import * as Mappers from "../mappers";
import { useParams } from "react-router";

const useStageSteps = () => {
  const { id } = useParams();
  const initialData = { items: [] };

  const { data = initialData, ...args } = useQuery(
    [Constants.ENTITY, "stage-steps"],
    async () => {
      const { data } = await Api.StageSteps({ id });

      const items = (get(data, "data") || []).map((item) =>
        Mappers.StageSteps(item),
      );

      return { items };
    },
    { initialData, keepPreviousData: true },
  );

  return { ...data, ...args };
};

export default useStageSteps;
